// removed by extract-text-webpack-plugin
module.exports = {"quelle":"src-components----Quelle-module---quelle---2IDdP","text":"src-components----Quelle-module---text---32Fon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quelle.module.css
// module id = 614
// module chunks = 168707334958949